import errorImages from "common/constants/errorImages";

import Page from "client/common/components/layouts/Page";
import Subheader from "client/common/components/layouts/Subheader";
import Body from "client/common/components/layouts/Body";
import Results from "client/common/components/results/Results";
import { useClientQuery } from "client/accounts/hooks";
import { urls } from "client/routes";

import { useSubscriptionsQuery } from "../hooks";
import ListSubscription from "./ListSubscription";

import styles from "../styles/SubscriptionsPage.module.less";

const Subscriptions = () => {
  const { data: subscriptions = [], isLoading, error } = useSubscriptionsQuery();
  const { data: client, isLoading: isClientLoading } = useClientQuery();

  if (isLoading || isClientLoading) {
    return <Results.Loading description="Loading Autoships" />;
  }

  if (error || !client) {
    return <Results.FetchError entityName="Autoships" error={error} />;
  }

  if (!subscriptions.length) {
    return (
      <Results.None
        image={errorImages.EmptyAutoships}
        header="You don't have any Autoships set up yet"
        dest={urls.products.search()}
        button="Search Products"
      />
    );
  }

  return (
    <div className={styles.subscriptions}>
      {subscriptions.map((subscription, i) => (
        <ListSubscription
          key={subscription.id}
          subscription={subscription}
          index={i}
          total={subscriptions.length}
        />
      ))}
    </div>
  );
};

const SubscriptionsPage = () => {
  return (
    <Page>
      <Subheader
        title="My Autoships"
        description="Check the status of autoships and quickly manage schedules"
      />
      <Body>
        <Subscriptions />
      </Body>
    </Page>
  );
};

export default SubscriptionsPage;
